/**
 * The one place that opens an address outside the app and that copies text.
 *
 * The app may later run inside Electron or Capacitor. There a plain link can
 * open inside the app window, or replace the app, and the browser clipboard is
 * less reliable on Android. When that happens, only these two functions change:
 * `openExternal` calls Electron's `shell.openExternal` or Capacitor's Browser
 * plugin, and `copyText` calls Capacitor's Clipboard plugin.
 * See docs/specs/record-properties-panel.md.
 */

/**
 * Opens a web address in a new tab. An address the browser hands to another
 * app, such as `mailto:` or `tel:`, opens there without leaving an empty tab.
 */
export function openExternal(url: string): void {
    if (/^https?:/i.test(url)) {
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    window.location.assign(url);
}

/** Copies text to the clipboard. Resolves false when the browser refused. */
export async function copyText(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
}
